/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDE0IDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi43MSAwTDYuNzEgNkwwLjcxIDBMMCAwLjcxTDYuNzEgNy40MkwxMy40MiAwLjcxTDEyLjcxIDBaIiBmaWxsPSIjN0Y3RjdGIi8+PC9zdmc+";